module.exports = __webpack_public_path__ + "img/20200801_130300.9a38a335.jpg";